















































import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import Ship, {
  ShipPredefinedStyle,
} from '@/shared/components/ship.component.vue';

@Component({
  components: {
    Ship,
  },
})
export default class SelectTag extends Vue {
  @Prop({ default: 'Selecciona las etiquetas' }) private placeholder!: string;
  @Prop({ default: 'Etiquetas' }) private label!: string;
  @Prop({ default: false }) private ship!: boolean;
  @Prop({ default: false }) private saldo!: boolean;
  @Prop({ default: false }) private onlyReading!: boolean;
  @Prop({ default: () => [] }) private items!: Array<any>;
  @Model('change', { type: Array, default: () => [] })
  readonly selectedModel!: Array<any>;

  private content: string = '';
  private isFocused: boolean = false;
  private shipPredefinedStyle = ShipPredefinedStyle;
  private isBlurred = false;
  private finishLoading = false;
  private isOpen = false;
  private dontClose = false;
  private update = 0;

  @Watch('selected')
  private watchSelected() {
    if (this.finishLoading ) {
      this.$emit('change', [...this.selected]);
    }
  }

  @Watch('items')
  private watchItems() {
    this.updateItems();
  }

  /**
   * Watch that triggers when A PAGAR price is negative to add SALDO tag to the
   * purchase. It gets removen when the price is not negative
   * @param newVal boolean
   */
  @Watch('saldo')
  private watchSaldo(newVal:boolean) {
    if (newVal){
      this.items.filter(item => item.name=="SALDO")[0].active = true
    } else {
      // this.items.filter(item => item.name=="SALDO")[0].active = false
      delete this.items.filter(item => item.name=="SALDO")[0].active

    }
    this.$forceUpdate()
  }

  /**
   * Reiniciar valores seleccionados
   */
  public newPurchase() {
    // this.items.forEach(item => {
    //   if(item.active){
    //     delete item.active;
    //   }
    // });

    for (let i = 0; i < this.items.length; i++) {
      delete this.items[i].active
    }
    this.$forceUpdate()


  }


  @Watch('selectedModel')
  private watchSelectedModel(newVal: Array<any>, oldVal: Array<any>) {
    this.updateItems();
  }

  mounted() {
    this.updateItems();
  }

  private updateItems() {
    this.selectedModel.forEach((e: any) => {
      const index = this.items.findIndex((item) => item.id === e.id);
      if (index !== -1) {
        this.items[index].active = true;
      }
    });
  }

  get filterItems(): Array<any> {
    if (this.content) {
      return this.items.filter((e) =>
        e.name.toLowerCase().includes(this.content.toLowerCase()),
      );
    } else {
      return this.items;
    }
  }

  get selected() {
    return this.items.filter((e) => e.active);
  }
  private handleFocus() {
    if (this.onlyReading) {
      return;
    }
    this.finishLoading=true;
    this.selectState(true);
    this.$emit('on-focus');
  }

  private handleContentClick() {
    this.dontClose = true;
  }

  private handleBlur() {
    setTimeout(() => {
      if (this.dontClose) {
        (this.$refs.input as HTMLInputElement).focus();
      }
      this.selectState(this.dontClose);
      this.dontClose = false;
    }, 200);
  }

  private selectState(open: boolean) {
    this.isFocused = open;
    this.isOpen = open;
  }
}
